import { Nullish } from '../../types/helpers';
import { isNullish } from '../assertFunctions';

export type SizeInputParserReturn = {
  value: number;
  unit: string;
  composite: string;
};

type InputSizeParser = (
  sizeArg: string | number | Nullish,
  validUnits?: string[],
) => SizeInputParserReturn | undefined;

export const validUnitsBase = [
  'px',
  'rem',
  'em',
  'vw',
  'vh',
  'vmin',
  'vmax',
  '%',
];

/** Size input parser for the UserName and UserAvatar components */
export const sizeInputParser: InputSizeParser = (
  sizeArg,
  validUnits = validUnitsBase,
) => {
  if (isNullish(sizeArg)) {
    return undefined;
  }
  if (typeof sizeArg === 'number') {
    return { value: sizeArg, unit: 'px', composite: `${sizeArg}px` };
  }
  const sizeArgument = sizeArg
    .split('')
    .filter((char) => char !== ' ')
    .join('');
  // eslint-disable-next-line no-useless-escape
  const digitsRegex = /^\d+([\.,]{0,1})\d*/;
  const sizeMatch = sizeArgument.match(digitsRegex);
  if (!sizeMatch) {
    return undefined;
  }
  let sizeNumber = sizeMatch[0];
  const sizeUnit = sizeArgument.replace(sizeNumber, '');
  // Replace any decimal commas with point commas.
  sizeNumber = sizeNumber.replace(',', '.');

  let isValidUnit = false;
  for (const unit of validUnits) {
    if (unit === sizeUnit) {
      isValidUnit = true;
      break;
    }
  }

  if (!(sizeUnit && isValidUnit)) {
    return {
      value: Number(sizeNumber),
      unit: 'px',
      composite: `${sizeNumber}px`,
    };
  }
  return {
    value: Number(sizeNumber),
    unit: sizeUnit,
    composite: `${sizeNumber}${sizeUnit}`,
  };
};

export const assertedSizeInputParser = (
  ...args: Parameters<InputSizeParser>
): SizeInputParserReturn => {
  const result = sizeInputParser(...args);
  if (!result) {
    throw new Error(`Size parsing failed for arguments: ${args.join(', ')}`);
  }
  return result;
};
